import * as React from 'react';
import { StoreContext } from '../../utils';
import { Store } from '../../store/Store';

export class LehrerDashboard extends React.Component {
  static contextType = StoreContext;
  declare context: Store;

  render() {
    const { gruppe, gruppenmitglieder, portalStore, vorgaben, lehrer } = this.context.lehrerStore;

    return (
      <div className="row">
        <div className="col-xl-7">
          {/*begin::Engage Widget 11*/}
          <h2>Hallo {lehrer.name},</h2>
          <p>Sie sind jetzt in ihrem Schlaukopf Lehrerbereich eingeloggt.</p>
          <p style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ fontSize: 80 }}>☚</span>
            <span style={{ marginLeft: 10, fontSize: 14 }}>Hier finden Sie ihre Gruppen.</span>
          </p>
          {/*end::Engage Widget 11*/}
        </div>
        <div className="col-lg-4">
          {/*begin::Card*/}
          <div className="card card-custom gutter-b example example-compact">
            <div className="card-header">
              <h3 className="card-title">Name</h3>
            </div>
            {/*begin::Form*/}
            <form className="form" method="POST">
              <div className="card-body">
                <div className="form-group">
                  <label>Ihr Name:</label>
                  <input
                    name="neuerName"
                    type="text"
                    className="form-control form-control-solid"
                    placeholder="z.B. Herr Müller"
                    defaultValue={lehrer.name}
                  />
                  <span className="form-text text-muted">z.B. Herr Fuchs</span>
                </div>
                <button type="submit" className="btn btn-light-primary font-weight-bold mr-2">
                  Speichern
                </button>
              </div>
            </form>
            {/*end::Form*/}
          </div>
          {/*end::Card*/}

          {/*begin::Card*/}
          <div className="card card-custom gutter-b example example-compact">
            <div className="card-header">
              <h3 className="card-title">E-Mail</h3>
            </div>
            {/*begin::Form*/}
            <form className="form" method="POST">
              <div className="card-body">
                <div className="form-group">
                  <label>Ihre E-Mailadresse:</label>
                  <h4>{lehrer.email}</h4>
                </div>
                <a href="/auth/transfer" target="_blank" className="btn btn-light-primary font-weight-bold mr-2">
                  Ändern
                </a>
              </div>
            </form>
            {/*end::Form*/}
          </div>
          {/*end::Card*/}
        </div>
      </div>
    );
  }

  componentDidMount() {
    const { lehrer } = this.context.lehrerStore;
    if (!lehrer.acceptAt) {
      this.requireAcceptance();
    }
  }

  async requireAcceptance() {
    const result = await window.swal.fire({
      title: 'Nutzungs- und Datenschutzbedingungen',
      icon: 'info',
      html: `
<p>
Ich akzeptiere die <a href="/info/datenschutz" target="_blank">Nutzungs- und Datenschutzbedingungen</a> von Schlaukopf.
         </p>
          <p>
      <small>Die Nutzung des Dienstes ist kostenlos. Es werden nur die notwendigsten Daten erfasst und gespeichert. Schlaukopf darf mich per E-Mail kontaktieren. Nach 365 Tagen Inaktivität werden alle meine Daten gelöscht.</small>
     </p>


      `,
      confirmButtonText: 'Akzeptieren',
      showCloseButton: false,
      showCancelButton: false,
      focusConfirm: true,
    });

    if (!result.value) {
      await window.swal.fire({
        icon: 'error',
        title: 'Fehler...',
        text: 'Sie können den Schlaukopf-Lehrerbereich erst nutzen, wenn Sie die Nutzungs- und Datenschutzbedingungen akzeptieren!',
      });
      this.requireAcceptance();
    } else {
      await window.swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Ok, Sie können jetzt loslegen.',
        showConfirmButton: false,
        timer: 1500,
      });

      location.search = '?accept=1';
    }
  }
}
